
export type ResourceKey = string;

export interface ResourceLoadContext {
  device: GPUDevice;
  fetchPrivate(path: string): Promise<Response>;
}

export abstract class Resource<T> {
  readonly key: ResourceKey;
  protected _value?: T;

  constructor(key: ResourceKey) {
    this.key = key;
  }

  get isLoaded(): boolean {
    return this._value !== undefined;
  }

  get value(): T {
    if (this._value === undefined) {
      throw new Error(`Resource not loaded: ${this.key}`);
    }
    return this._value;
  }

  abstract load(ctx: ResourceLoadContext): Promise<T>;
  abstract dispose(ctx: ResourceLoadContext): void;
}